/**
 * 悬浮窗
 * */
Vue.component(
    'suspension-window',
    resolve => require(["../../components/SuspensionWindow"], resolve)
);


// 付费去广告
Vue.component(
    'sus-adfree',
    resolve => require(["../../components/sus/adFree"], resolve)
);
// 商务合作
Vue.component(
    'sus-business',
    resolve => require(["../../components/sus/business"], resolve)
);
// 优品推荐
Vue.component(
    'sus-product',
    resolve => require(["../../components/sus/product"], resolve)
);
// 宽带特惠
Vue.component(
    'sus-ycs',
    resolve => require(["../../components/sus/ycs"], resolve)
);
// 网速报告
Vue.component(
    'sus-report',
    resolve => require(["../../components/sus/report"], resolve)
);
// 帮助反馈
Vue.component(
    'sus-help',
    resolve => require(["../../components/sus/help"], resolve)
);
// 常见问题
Vue.component(
    'sus-question',
    resolve => require(["../../components/sus/question"], resolve)
);
// 返回顶部
Vue.component(
    'sus-top',
    resolve => require(["../../components/sus/top"], resolve)
);
//轻松赚钱
Vue.component(
    'sus-make',
    resolve => require(["../../components/sus/make"], resolve)
);
// 添加测速点
Vue.component(
    'sus-add-nodes',
    resolve => require(["../../components/sus/addNodes"], resolve)
);
// 下载极速版
Vue.component(
    'sus-jisu-download',
    resolve => require(["../../components/sus/jisu"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/sus.js